import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: var(--app-height);
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 999999;

  ${media.greaterThan("medium")`
    align-items: baseline;
    justify-items: center;
    background-size: cover;
    grid-row-gap: 28px;
  `}
`;

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
